import { render, staticRenderFns } from "./obv.vue?vue&type=template&id=204fe122&scoped=true&"
import script from "./obv.vue?vue&type=script&lang=js&"
export * from "./obv.vue?vue&type=script&lang=js&"
import style0 from "./obv.vue?vue&type=style&index=0&id=204fe122&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204fe122",
  null
  
)

export default component.exports